import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "../pages/HomePage";
import { buildCompleteHead } from "../utils/seo";

export const Route = createFileRoute("/$lang/")({
  head: ({ params }) => {
    const currentPath = `/${params.lang}`;
    const canonicalUrl = `https://lotin.uz${currentPath}`;
    const seoData = buildCompleteHead(
      params.lang as "oz" | "uz" | "ru",
      "home",
      canonicalUrl,
      currentPath,
      currentPath,
    );

    return {
      meta: [{ title: seoData.title }, ...seoData.meta],
      links: seoData.links,
    };
  },
  component: HomePage,
});
